import dateformat from 'dateformat';

export default {

  formatDate(date) {
    return dateformat(new Date(date), 'dd/mm/yyyy')
  },

  getDateRangeStr: function (from, to) {
    if (from === to) {
      return `le ${this.formatDate(from)}`
    } else {
      let fromStr = from
        ? `${to ? 'du' : 'depuis le'} ${this.formatDate(from)}`
        : ''
      let toStr = to
        ? `${from ? 'au' : 'jusqu\'au'} ${this.formatDate(to)}`
        : ''
      return `${fromStr}${fromStr !== '' ? ` ${toStr}` : toStr}`
    }
  },

  getDelayRangeStr: function (from, to) {
    if (from === to) {
      return from > 0
        ? `en ${from} jour${from > 1 ? 's' : ''}`
        : 'immédiat'
    } else {
      let fromStr = `${from} jour${from > 1 ? 's' : ''}`
      let toStr = `${to} jour${to > 1 ? 's' : ''}`
      return from > 0
        ? `sous ${to ? `${from} à ${toStr}` : fromStr}`
        : `sous ${toStr}`
    }
  }
}
